import { clsx } from 'clsx'
import hssLoader from '~/components/media/hss-loading.gif'

interface Props {
  size?: 'sm' | 'md' | 'lg'
}

const HssLoader = ({ size = 'lg' }: Props = {}) => (
  <img
    src={hssLoader}
    alt="loader gif"
    className={clsx('h-auto max-w-full', {
      'w-16': size == 'sm',
      'w-24': size == 'md',
      'w-[125px]': size == 'lg', // exact GIF max size
    })}
  />
)

export default HssLoader
